var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"m20 6v10a4 4 0 0 1 -8 0v-10a4 4 0 0 1 8 0z"}}),_c('path',{attrs:{"d":"m17 23.94v4.06h4a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2h4v-4.06c-3.94-.43-7-3.38-7-6.94v-3a1 1 0 0 1 2 0v3c0 2.76 2.69 5 6 5s6-2.24 6-5v-3a1 1 0 0 1 2 0v3c0 3.56-3.06 6.51-7 6.94z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }